module.exports = __webpack_public_path__ + "static/media/supplies_icon.94782874.svg";